import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NavigationComponent } from "../navigation/navigation.component";

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NavigationComponent
]
})
export class MainPageComponent {
  @Input() isloggedIn = true;
  @Input() isExpanded = true;

  public toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }

}
